export const hadleFilterStructureData = (filters) => {
  const filterKeys = [];
  const filterColors = [];

  for (const key in filters) {
    console.log("filters[key]", filters[key]);
    if (filters[key]?.options?.length) {
      filterKeys.push({
        title: filters[key]?.label,
        titleCode: filters[key]?.code,
        options: filters[key]?.options,
      });
    }

    // if (key == "color") {
    //   filterColors.push({
    //     title: key,
    //     list: filters[key]?.buckets,
    //   });
    // }
  }

  return { filterKeys, filterColors };
};

export function getObjectsInData(arr) {
  let result = [];
  function handleData(arr) {
    arr?.forEach((item) => {
      if (result.length == 0 || result?.find((itemF) => itemF.id != item.id)) {
        result.push(item);
      }

      if (
        Array.isArray(item?.children_data) &&
        item?.children_data &&
        item?.children_data?.length > 0
      ) {
        handleData(item?.children_data);
      }
    });
  }
  handleData(arr);
  return result;
}

export function generateSlugs(categories, parentSlug = "") {
  if (!Array.isArray(categories)) return {};
  let slugs = {};

  categories?.forEach((category) => {
    // Build the current slug using the parent slug and the current category's url_key
    const currentSlug = parentSlug
      ? `${parentSlug}/${category?.url_key}`
      : category?.url_key;

    // Add the current slug to the slugs map
    slugs[category?.id] = currentSlug;

    // Recursively generate slugs for the child categories
    if (category?.children_data && category?.children_data.length > 0) {
      const childSlugs = generateSlugs(category?.children_data, currentSlug);
      slugs = { ...slugs, ...childSlugs };
    }
  });

  return slugs;
}
